// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'google';

export const Component = () => (
  <path
    fill='currentColor'
    d='M14.393 9.255c0 1.068-.207 1.965-.656 2.758a4.77 4.77 0 0 1-1.862 1.931c-.793.449-1.724.69-2.758.69a5.41 5.41 0 0 1-2.138-.448c-.62-.242-1.207-.656-1.758-1.173a4.632 4.632 0 0 1-1.173-1.758A5.52 5.52 0 0 1 3.6 9.117c0-.759.172-1.483.448-2.138.276-.655.656-1.242 1.173-1.758s1.137-.931 1.758-1.173A5.409 5.409 0 0 1 9.117 3.6c1.448 0 2.655.483 3.69 1.448l-1.518 1.449c-.552-.586-1.275-.862-2.172-.862-.62 0-1.172.172-1.724.482a3.56 3.56 0 0 0-1.242 1.242c-.275.517-.448 1.103-.448 1.758s.172 1.241.448 1.758c.311.518.724.931 1.242 1.242.552.31 1.104.482 1.724.482.38 0 .759-.069 1.138-.172.275-.103.586-.241.862-.448.276-.241.483-.414.586-.586.138-.138.242-.345.38-.62.069-.138.103-.311.137-.552H9.117V8.324h5.172c.07.31.104.62.104.93z'
  />
);

export const viewBox = '0 0 18 18';
